import { useAddProductsFromInventoryMutation } from '@/core/api/graphql/forshawGraphqlApi.generated.ts'
import { useCallback, useState } from 'react'
import { useAccountBranchIdsParams } from '@/core/hooks/useAccountBranchIdsParams.ts'

const useAddProductsFromInventory = () => {
  const [addProductsFromInventoryMutation] =
    useAddProductsFromInventoryMutation()
  const { branchId } = useAccountBranchIdsParams()

  const [isLoading, setIsLoading] = useState(false)

  const addProductsFromInventory = useCallback(
    async (productIds: number[]) => {
      setIsLoading(true)

      try {
        const response = await addProductsFromInventoryMutation({
          branchId,
          productIds,
        })

        if ('error' in response) {
          throw new Error('Failed to add products from inventory')
        }

        return response
      } catch (e) {
        console.error(e)
        throw e
      } finally {
        setIsLoading(false)
      }
    },
    [addProductsFromInventoryMutation, branchId],
  )

  return { addProductsFromInventory, isLoading }
}

export { useAddProductsFromInventory }
